var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages"},[(_vm.user.role == 'manager' || _vm.user.role == 'admin')?_c('MANAGERHOME'):_vm._e(),(_vm.user.role == 'officer')?_c('OFFICERHOME'):_vm._e(),(_vm.user.role == 'member')?_c('USERRHOME'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }